(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EdicionDetailsController', EdicionDetailsController);

    /* @ngInject */
    function EdicionDetailsController($timeout, $stateParams, edicion) {
        var vm = this;

        vm.edicion = edicion;
        vm.responsables = edicion.responsables;

        vm.editores = vm.responsables.filter(function (elemento) {
            return elemento.rol === "EDIT";
        });

        vm.impresores = vm.responsables.filter(function (elemento) {
            return elemento.rol === "IMPR";
        });

        vm.traductores = vm.responsables.filter(function (elemento) {
            return elemento.rol === "TRAD";
        });

        vm.otros = vm.responsables.filter(function (elemento) {
            return elemento.rol === "OTRO";
        });

        // Gallery
        //Mostrar las imágenes aquí tiene su dificultad, dado que hay que separarlas por cada ilustración
        //Lo que se ha hecho, es añadir un campo en cada edicion.ilustraciones[numeroIlustracion], que será una lista con las imagenes (elem multimedia asociados)
        vm.numeroIlustracion = 0;
        vm.edicion.ilustraciones.forEach(function (ilustracion) {
            vm.imagenesAux= [];
            ilustracion.imagenes.forEach(function (imagen) {
                if (imagen.path) {
                    vm.imagenesAux.push({
                        id: imagen.id,
                        url: 'upload/ediciones/' + vm.edicion.id + '/ilustraciones' + '/' + ilustracion.id + '/' + imagen.path,
                        thumbUrl: 'upload/ediciones/' + vm.edicion.id + '/ilustraciones' + '/' + ilustracion.id + '/n_' + imagen.path
                    });
                }
            });
            vm.edicion.ilustraciones[vm.numeroIlustracion].imagenesMostrar= [];
            vm.edicion.ilustraciones[vm.numeroIlustracion].imagenesMostrar = vm.imagenesAux;
            vm.numeroIlustracion++;
        });
    }

})(angular);
